<template>
  <div class="row">
    <div class="col">
      <!-- Location Name -->
      <div class="row">
        <div class="col-4">
          <z-input v-model="firmName" name="firmName" label="Name" :validator="v$" @keyup="changed(true)"
            @change="changed(true)" />
        </div>
        <div class="col-2">
          <z-select v-model="firmClass" name="firmClass" label="Class" :options="classes" :disabled="!isSuperAdmin"
            @change="changed(true)" />
        </div>
        <div class="col-2">
          <z-select v-model="firmType" name="firmType" label="Type" :options="types" :disabled="true" />
        </div>
        <div class="col">
          <input v-model="isInactive" type="checkbox" true-value="true" false-value="false"
            class="custom-checkbox me-2 custom-inactive-check" @click="changed(true)" />
          <span class="custom-inactive">
            Inactive?
            <div ref="info" data-bs-toggle="tooltip" data-bs-placement="top"
              title="This setting this will also apply to any child locations. Users will also become inactive.">
              <i class="fas fa-info-circle"></i>
            </div>
          </span>
        </div>
      </div>
      <!-- Additional ID references -->
      <div class="row custom-border-top">
        <div class="col">
          <z-input v-model="firmId" name="firmId" :label="firmIdName" :disabled="!isSuperAdmin"
            @keyup="changed(false)" @change="changed(false)" />
        </div>
        <div class="col">
          <z-input v-model="firmNumber" name="firmNumber" label="Number" :disabled="!isSuperAdmin"
            @keyup="changed(false)" @change="changed(false)" />
        </div>
        <div class="col"></div>
        <div class="col"></div>
      </div>
      <!-- Type and IsInactive? -->
      <div class="row">
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col-3">
          <!-- Lookup for User Contact for this Location -->
          <z-search v-model.trim="searchTerm" name="search" class="custom-search-user" label="Main Contact:"
            placeholder="Search" :disabled="isLoading" />
          <div v-if="isFoundUsers" class="custom-found-user">
            <ul>
              <li v-for="user of foundFirmUsers" :key="user.user" :value="user.user" @click="selectUser(user)">
                {{ formatName(user) }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col">
          <span class="custom-contact">{{ mainContact }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div v-if="isOkayToMove" class="row mt-1">
          <div class="col">
            <div class="row custom-border-top">
              <div class="col">
                <p>To move this location to another, search and select the location (to move to) and click the 'Move'
                  button.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <Multiselect ref="searchLocation" v-model="foundLocation" class="form-control custom-multiselect"
                  placeholder="type to search" :close-on-select="true" :filter-results="false" :min-chars="1"
                  :resolve-on-load="false" :delay="500" :searchable="true" :open-direction="'top'" :options="async (query) => {
                    return await fetchLocations(query)
                  }
                    " label="firmName" value-prop="firm" @select="selectedLocation" />
              </div>
              <div class="col-1">
                <button class="btn btn-primary btn-sm" @click="reassignLocation">Move</button>
              </div>
              <div class="col"></div>
            </div>
            <div class="row">
              <div class="col">
                <p><b>Note:</b> Be sure to choose a "parent" location that is identical to this location's current
                  parent.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { lookupStore } from '@/stores/lookup'
import { Tooltip } from 'bootstrap'
import ZSearch from '@/components/utilities/elements/Search.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import Multiselect from '@vueform/multiselect'
export default {
  name: 'LocationBasic',
  components: {
    ZSearch,
    ZInput,
    ZSelect,
    Multiselect
  },
  props: {
    parent: Object,
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  emits: ['message', 'changed', 'saved', 'moved'],
  data() {
    return {
      foundLocation: null,
      isPushing: false,
      rules: {
        firmName: { required },
        firmType: { required },
        firmClass: { required }
      },
      v$: null
    }
  },
  beforeMount() {
    this.v$ = useVuelidate(this.rules, this.location)
    this.isPushing = false
    this.newUsername = ''
    this.editingUsername = false
  },
  mounted() {
    new Tooltip(this.$refs.info)
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(lookupStore, ['lookups']),
    ...mapState(locationStore, ['loading', 'location', 'userSearchTerm', 'foundFirmUsers', 'foundLocations']),
    isLoading() {
      let _is = false
      if (this.loading) {
        _is = this.loading.users || this.loading.locations
      }
      return _is
    },
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    types() {
      let _types = []
      if (this.lookups) {
        _types = this.lookups['FirmType']
      }
      console.log('Firm Types', _types)
      return _types
    },
    classes() {
      let _classes = []
      if (this.lookups) {
        _classes = this.lookups['FirmClass']
      }
      console.log('Firm Classes', _classes)
      return _classes
    },
    isOkayToMove() {
      let _is = false
      if (this.location) {
        if (this.location.firmType > 3) {
          _is = true
        }
      }
      return _is
    },
    firmName: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmName
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmName',
          value: value
        })
      }
    },
    firmType: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmType
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmType',
          value: parseInt(value)
        })
      }
    },
    firmClass: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmClass
        }
        console.log('Firm Class', _data)
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmClass',
          value: parseInt(value)
        })
      }
    },
    postalCode: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.postalCode
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'postalCode',
          value: value
        })
      }
    },
    isInactive: {
      get() {
        let _data = false
        if (this.location) {
          _data = this.location.isInactive
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'isInactive',
          value: value === 'true'
        })
      }
    },
    firmId: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmId
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmId',
          value: value
        })
      }
    },
    firmNumber: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmNumber
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmNumber',
          value: value
        })
      }
    },
    opusId: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.opusId
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'opusId',
          value: value
        })
      }
    },
    mainContact() {
      let _data = null
      if (this.location) {
        _data = this.location.mainContact
      }
      return _data
    },
    searchTerm: {
      get() {
        return this.userSearchTerm
      },
      set(value) {
        this.setUserSearchTerm(value)
        this.searchForUsers()
      }
    },
    isFoundUsers() {
      let _is = false
      if (this.foundFirmUsers) {
        if (this.foundFirmUsers.length > 0) {
          _is = true
        }
      }
      return _is
    },
    isInsurer() {
      let _is = false
      if (this.location) {
        if ([1, 5].includes(this.location.firmClass)) {
          _is = true
        }
      }
      return _is
    },
    isProvider() {
      let _is = false
      if (this.location) {
        if ([2, 3].includes(this.location.firmClass)) {
          _is = true
        }
      }
      return _is
    },
    firmIdName() {
      let _name = 'LaunchPad Id'
      if (this.isInsurer && this.location.firmType === 2) {
        _name = _name + ' (of Insurer, not Partner)'
      } else if (this.isProvider && this.location.firmType === 2) {
        _name = _name + ' (of Provider - Corporate)'
      } else if (this.isProvider && this.location.firmClass === 3) {
        _name = _name + ' (of Service Provider)'
      } else {
        _name = _name + ' (optional)'
      }
      return _name
    },
  },
  methods: {
    ...mapActions(locationStore, [
      'setLocation',
      'saveLocation',
      'setUserSearchTerm',
      'searchFirmUser',
      'pushLocation',
      'searchLocations',
      'resetFoundLocations',
      'moveLocation'
    ]),
    changed(is) {
      this.$emit('changed', is)
    },
    async searchForUsers() {
      console.log('Search Users...')
      let data = {
        firm: this.parent.parent,
        search: this.userSearchTerm
      }
      await this.searchFirmUser(data)
    },
    formatName(user) {
      let data = null
      if (user.firstname) {
        data = `${user.lastname}, ${user.firstname}`
      } else {
        data = user.lastname
      }
      return data
    },
    selectUser(user) {
      let data = null
      console.log('Selected User', user)
      if (user.firstname) {
        data = `${user.lastname}, ${user.firstname}`
      } else {
        data = user.lastname
      }
      this.setLocation({
        name: 'mainContactId',
        value: parseInt(user.user)
      })
      this.setLocation({
        name: 'mainContact',
        value: data
      })
      this.setUserSearchTerm(data)
      this.changed()
    },
    async fetchLocations(query) {
      let search = {
        search: query,
        type: null,
        firmType: this.firmType,
        firm: this.location.firm
      }
      return await this.searchLocations(search)
    },
    selectedLocation() {
      this.$nextTick(() => {
        let found = this.foundLocations.find((x) => parseInt(x.firm) === parseInt(this.foundLocation))
        if (found) {
          console.log('Found Location', found)
        }
      })
    },
    async reassignLocation() {
      let data = {
        firm: this.location.firm,
        firm2: this.foundLocation
      }
      console.log('Moving Location', data)
      this.resetFoundLocations()
      this.$refs.searchLocation.clear()
      this.$refs.searchLocation.clearSearch()
      this.foundLocation = null
      let result = await this.moveLocation(data)
      console.log('Move Result', result)
      if (result !== undefined && result !== null) {
        if (parseInt(result) > 0) {
          // refresh
          this.$emit('moved', data)
        } else {
          alert('Move failed, ensure the Location can be a valid "child" under the targeted move location.')
        }
      }
    },
    async save() {
      let response = {
        valid: false,
        firm: null,
        msg: null
      }
      try {
        const valid = await this.v$.$validate()
        if (valid) {
          console.log('Save Location', this.location)
          let result = await this.saveLocation()
          response.valid = true
          response.firm = result
          this.$emit('saved', result)
        } else {
          let msg = 'Location Not Valid'
          response.msg = msg
          this.$emit('message', msg)
        }
      } catch (e) {
        console.error(e)
        response.msg = 'Error: Unable to save'
        this.message = response.msg
      }
      return response
    }
  }
}
</script>
<style lang="scss">
.custom-inactive {
  position: relative;
  display: inline-flex;

  div {
    color: #0a58ca;
    margin-left: 5px;
    top: -5px;
  }
}

.custom-inactive-check {
  margin-top: 30px;
}

.custom-inline {
  display: inline-flex;
}

.custom-info {
  position: absolute;
  top: 0;
  right: 20px;
  color: #0a58ca;
}

.custom-search-icon {
  position: relative;
  top: 0px;
}

.custom-border-top {
  border-top: 1px solid #dee2e6;
  padding-top: 10px;
}

.custom-search-user {
  z-index: 10;
}

.custom-found-user {
  position: relative;
  width: 90%;
  max-height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #dee2e6;
  padding: 0;
  top: -2px;
  z-index: 5;

  ul {
    list-style: none;
    margin: 0 auto;
    padding: 8px;
    cursor: pointer;

    :hover {
      background-color: #0d6efd;
      color: #fff;
    }

    li {
      padding: 2px;
    }
  }
}

.custom-icon {
  width: 100%;
  display: inline;
}

.custom-firm-name {
  color: red;
  font-size: 0.9em;
  font-weight: 500;
  margin-bottom: 10px;
  position: relative;
  top: -10px;
}

.custom-border-top {
  border-top: 1px solid #dee2e6;
}

.custom-firm-number {
  font-size: 0.8em;
  font-weight: 600;
  position: relative;
  top: -10px;
  color: #ca0a0a;
}

.custom-contact {
  position: relative;
  top: 25px;
}
</style>
